import ReviewsCarousel from './ReviewsCarousel';
import TelStoreCover from './TelStoreCover';
import { useState } from 'react';

import LeadForm from './LeadForm';
import PageMeta from './PageMeta';
import { RedesignFooter, RedesignHeader, RedesignPage, SiteLink } from './RedesignShell';

const siteIncludes = [
  'анализ ниши и конкурентов',
  'проектирование структуры сайта',
  'разработку дизайна',
  'программирование и верстку',
  'SEO-оптимизацию',
];

const businessTasks = [
  'привлечение целевой аудитории',
  'рост трафика из поисковых систем',
  'увеличение заявок и продаж',
  'формирование доверия к компании',
  'автоматизация обработки заявок',
];

const siteTypes = [
  {
    href: 'https://fatalitystudio.ru/services/websites/landing/',
    title: 'Лендинг сайт под ключ',
    paragraphs: ['Одностраничный сайт под ключ подходит для рекламы.', 'Используется для быстрых продаж и теста гипотез.'],
    meta: 'реклама · гипотезы',
  },
  {
    href: 'https://fatalitystudio.ru/services/websites/corporate/',
    title: 'Корпоративный сайт под ключ',
    paragraphs: ['Корпоративный сайт под ключ раскрывает услуги компании.', 'Формирует доверие и привлекает клиентов из поиска.'],
    meta: 'компания · услуги',
  },
  {
    href: null,
    title: 'Сайт визитка под ключ',
    paragraphs: ['Сайт визитка под ключ — базовое решение.', 'Подходит для малого бизнеса и старта.'],
    meta: 'старт · малый бизнес',
  },
  {
    href: 'https://fatalitystudio.ru/services/websites/ecommerce/',
    title: 'Интернет- магазин под ключ',
    paragraphs: ['Интернет магазин под ключ — сложный проект.', 'Включает каталог товаров, корзину и оплату.'],
    meta: 'каталог · оплата',
  },
  {
    href: '/services/websites/service-business/',
    title: 'Сайт услуг под ключ',
    paragraphs: ['Сайт услуг под ключ ориентирован на заявки.', 'Используется для B2B и локального бизнеса.'],
    meta: 'B2B · заявки',
  },
  {
    href: null,
    title: 'Персонализированные сайты под ключ',
    paragraphs: ['Разрабатываются под задачи бизнеса.', 'Учитывают нишу, конкурентов и аудиторию.'],
    meta: 'ниша · аудитория',
  },
];

const includedSteps = [
  {
    title: 'Аналитика и проектирование',
    paragraphs: ['Проводится анализ ниши.', 'Собирается семантическое ядро.', 'Прорабатывается структура страниц.'],
  },
  {
    title: 'UX/UI дизайн сайта',
    paragraphs: ['Разрабатывается уникальный дизайн.', 'Учитывается поведение пользователей.', 'Формируется удобный интерфейс.'],
  },
  {
    title: 'Разработка и верстка',
    paragraphs: ['Выполняется программирование сайта.', 'Делается адаптивная верстка.', 'Сайт корректно работает на всех устройствах.'],
  },
  {
    title: 'SEO оптимизация сайта',
    paragraphs: ['Настраиваются мета-теги и заголовки.', 'Оптимизируется структура сайта.', 'Улучшается скорость загрузки страниц.'],
  },
  {
    title: 'Тестирование и запуск',
    paragraphs: ['Проверяется работа всех функций.', 'Исправляются ошибки.', 'Сайт размещается на хостинге.'],
  },
];

const technologies = [
  {
    title: 'Frontend',
    paragraphs: ['HTML, CSS, JavaScript.', 'Адаптивная верстка и высокая скорость.'],
  },
  {
    title: 'Backend',
    paragraphs: ['PHP, Laravel, Bitrix.', 'Обработка данных и логика сайта.'],
  },
  {
    title: 'CMS и платформы (WordPress, Tilda, Bitrix и др.)',
    paragraphs: ['WordPress — универсальное решение.', 'Tilda — быстрый запуск лендингов.', 'Bitrix — сложные проекты и интернет-магазины.'],
  },
  {
    title: 'Интеграции и API',
    paragraphs: ['Подключаем CRM, аналитику и сервисы.', 'Интеграции упрощают работу бизнеса.'],
  },
];

const creationSteps = [
  {
    title: 'Анализ и бриф',
    paragraphs: ['Определяются цели проекта.', 'Изучается целевая аудитория.'],
  },
  {
    title: 'Проектирование структуры (прототип)',
    paragraphs: ['Создаются прототипы страниц.', 'Формируется логика сайта с учетом SEO.'],
  },
  {
    title: 'Дизайн сайта',
    paragraphs: ['Разрабатывается визуальная концепция c учетом конвесионности.', 'Согласовывается с Заказчиком.'],
  },
  {
    title: 'Разработка',
    paragraphs: ['Программисты реализуют функционал.', 'Делается верстка и интеграции.'],
  },
  {
    title: 'Запуск и оптимизация',
    paragraphs: ['Сайт публикуется.', 'Начинается продвижение и аналитика.'],
  },
];

const approachItems = [
  {
    title: 'Agile / Scrum',
    paragraphs: ['Работа делится на этапы.', 'Проект развивается постепенно.'],
  },
  {
    title: 'Прозрачные этапы',
    paragraphs: ['Заказчик видит ход работ.', 'Каждый этап согласуется.'],
  },
  {
    title: 'Фокус на продажах и конверсии',
    paragraphs: ['Сайт создается для результата.', 'Главная цель — заявки и продажи.'],
  },
  {
    title: 'SEO-first подход',
    paragraphs: ['SEO закладывается на старте.', 'Сайт сразу готов к продвижению.'],
  },
];

const collaborationFormats = [
  {
    title: 'Разработка сайта под ключ',
    paragraphs: ['Полный цикл работ.', 'От идеи до запуска.'],
  },
  {
    title: 'Выделенная команда',
    paragraphs: ['Команда работает только над проектом.', 'Подходит для сложных задач.'],
  },
  {
    title: 'Почасовая работа',
    paragraphs: ['Гибкий формат сотрудничества.', 'Оплата за фактические часы.'],
  },
  {
    title: 'Создание и продвижение сайта под ключ',
    paragraphs: ['Разработка + SEO + реклама.', 'Максимальный результат для бизнеса.'],
  },
];

const deliverables = [
  {
    title: 'Готовый сайт под ключ',
    paragraphs: ['Полностью рабочий веб-ресурс.', 'Готов к запуску и продажам.'],
  },
  {
    title: 'SEO оптимизацию и структуру',
    paragraphs: ['Сайт оптимизирован под поисковые системы.', 'Готов к росту трафика.'],
  },
  {
    title: 'Удобную систему управления (CMS)',
    paragraphs: ['Можно редактировать контент.', 'Не нужны программисты.'],
  },
  {
    title: 'Готовность к рекламе и продвижению',
    paragraphs: ['Сайт подходит для контекстной рекламы.', 'Подключается аналитика.'],
  },
  {
    title: 'Масштабируемую архитектуру',
    paragraphs: ['Сайт можно развивать.', 'Добавлять новые разделы и функции.'],
  },
];

const supportItems = [
  {
    title: 'Техническая поддержка',
    paragraphs: ['Обновления и исправления.', 'Контроль работы сайта.'],
  },
  {
    title: 'SLA и гарантии',
    paragraphs: ['Фиксированные сроки реакции.', 'Гарантия качества.'],
  },
  {
    title: 'Доработки',
    paragraphs: ['Добавление новых функций.', 'Развитие проекта.'],
  },
  {
    title: 'Ведение сайта под ключ',
    paragraphs: ['Контент, SEO и реклама.', 'Комплексное сопровождение.'],
  },
];

const priceFactors = ['количество страниц', 'сложность дизайна', 'функционал', 'интеграции', 'SEO-работы'];

const prices = [
  ['Лендинг сайт под ключ', '10–14 дней', 'от 70 000 ₽'],
  ['Сайт визитка под ключ', '2–3 недели', 'от 90 000 ₽'],
  ['Корпоративный сайт под ключ', '3–5 недель', 'от 150 000 ₽'],
  ['Интернет магазин под ключ', '4–6 недель', 'от 250 000 ₽'],
  ['Сайт с интеграциями', '5–8 недель', 'от 350 000 ₽'],
];

const relatedServices = [
  { href: 'https://fatalitystudio.ru/services/websites/corporate/', title: 'Разработка корпоративных сайтов', meta: 'компания · доверие' },
  { href: 'https://fatalitystudio.ru/services/websites/landing/', title: 'Создание лендингов', meta: 'реклама · конверсия' },
  { href: 'https://fatalitystudio.ru/services/websites/ecommerce/', title: 'Разработка интернет-магазинов', meta: 'каталог · продажи' },
  {
    href: '/services/websites/service-business/',
    title: 'Разработка сайта-услуг',
    meta: 'B2B · заявки',
  },
  { href: 'https://fatalitystudio.ru/services/seo/full-cycle/', title: 'SEO под ключ', meta: 'трафик · позиции' },
  { href: 'https://fatalitystudio.ru/services/yandex-maps/', title: 'Продвижение в Яндекс.Картах', meta: 'карты · локальный спрос' },
];

const reviews = [
  {
    name: 'Алексей Г.',
    role: 'владелец строительной компании',
    full: 'Алексей Г., владелец строительной компании',
    text: 'Заказали корпоративный сайт под ключ. Долго прорабатывали структуру и страницы услуг. В итоге через 4 месяца сайт вышел в топ по региональным запросам. Сейчас получаем регулярные заявки из поиска.',
  },
  {
    name: 'Ирина В.',
    role: 'владелец интернет-магазина одежды',
    full: 'Ирина В., владелец интернет-магазина одежды',
    text: 'Старый сайт не давал трафика. Решили сделать новый сайт интернет магазина под ключ. После запуска и базовой SEO-оптимизации через 2 месяца пошел рост. Сейчас трафик увеличился примерно в 3 раза.',
  },
  {
    name: 'Сергей П.',
    role: 'владелец автосервиса',
    full: 'Сергей П., владелец автосервиса',
    text: 'Сделали сайт визитку под ключ с SEO. Добавили страницы услуг и оптимизировали под локальные запросы. Через месяц начали зв',
  },
];

const faqItems = [
  {
    question: 'Сколько стоит сайт под ключ?',
    blocks: [
      'Стоимость сайта под ключ зависит от задач бизнеса и сложности проекта. Нельзя назвать одну фиксированную цену для всех.',
      'На цену влияет:',
      [
        'тип сайта: лендинг, сайт визитка, корпоративный сайт или интернет магазин',
        'количество страниц и блоков',
        'сложность дизайна и интерактивных элементов',
        'наличие интеграций (CRM, 1С, платежные системы)',
        'требования к SEO и продвижению сайта',
        'необходимость разработки уникального функционала',
      ],
      'Примерно:',
      [
        'лендинг под ключ — от 70 000 ₽',
        'сайт визитка — от 90 000 ₽',
        'корпоративный сайт — от 140 000 ₽',
        'интернет магазин под ключ — от 170 000 ₽',
      ],
      'Если нужен сайт под ключ с продвижением, стоимость увеличивается. Но это дает быстрый рост трафика и заявок.',
      'Точный расчет стоимости сайта под ключ делается после анализа ниши, конкурентов и целей проекта.',
    ],
  },
  {
    question: 'Почему сайт под ключ лучше шаблонного решения?',
    blocks: [
      'Шаблонные сайты кажутся дешевле. Но на практике они проигрывают по эффективности.',
      'Основные отличия:',
      [
        'структура не учитывает цели бизнеса',
        'нет проработки под SEO и поисковые системы',
        'слабая конверсия и низкая эффективность рекламы',
        'ограниченные возможности масштабирования',
      ],
      'Сайт под ключ разрабатывается с нуля под задачи компании.',
      'Что это дает:',
      [
        'индивидуальный дизайн и UX/UI',
        'проработанную структуру страниц',
        'адаптацию под целевую аудиторию',
        'готовность к SEO продвижению',
        'высокую скорость загрузки и стабильность',
      ],
      'В итоге сайт под ключ быстрее начинает приносить клиентов и окупает вложения.',
    ],
  },
  {
    question: 'Сроки создания сайта под ключ?',
    blocks: [
      'Сроки разработки сайта под ключ зависят от объема работ и сложности проекта.',
      'Средние сроки:',
      ['лендинг — 10–14 дней', 'сайт визитка — 2–3 недели', 'корпоративный сайт — 3–5 недель', 'интернет магазин — 4–8 недель'],
      'На сроки влияет:',
      [
        'скорость согласования дизайна и прототипов',
        'наличие готового контента (тексты, фото, видео)',
        'сложность функционала и интеграций',
        'количество правок на этапе разработки',
      ],
      'Важно понимать: быстрый запуск не должен ухудшать качество.',
      'Правильный процесс разработки включает:',
      ['аналитику и сбор требований', 'прототипирование структуры сайта', 'дизайн', 'верстку и программирование', 'тестирование и запуск'],
      'Только при соблюдении всех этапов сайт будет работать эффективно.',
    ],
  },
  {
    question: 'Что входит в услугу сайт под ключ?',
    blocks: [
      'Услуга создание сайта под ключ — это полный цикл работ от идеи до запуска.',
      'В стандартный пакет входит:',
      [
        'анализ бизнеса, ниши и конкурентов',
        'сбор семантического ядра и структуры сайта',
        'разработка прототипов страниц',
        'UX/UI дизайн сайта',
        'адаптивная верстка под мобильные устройства',
        'программирование на CMS (WordPress, Bitrix, Tilda и др.)',
        'базовая SEO оптимизация (мета-теги, структура URL, скорость)',
        'интеграции (CRM, формы, аналитика, платежные системы)',
        'тестирование сайта',
        'размещение на хостинге и запуск',
      ],
      'Дополнительно можно подключить:',
      ['SEO продвижение сайта', 'контекстную рекламу', 'SMM и маркетинг', 'ведение сайта под ключ'],
      'В результате клиент получает полностью готовый веб ресурс для бизнеса.',
    ],
  },
  {
    question: 'Можно ли заказать сайт под ключ с продвижением?',
    blocks: [
      'Да, это один из самых эффективных форматов.',
      'Создание и продвижение сайта под ключ позволяет:',
      [
        'сразу заложить правильную SEO структуру',
        'избежать дорогостоящих доработок в будущем',
        'быстрее выйти в топ поисковых систем',
        'начать получать органический трафик уже через 1–3 месяца',
      ],
      'В рамках такого подхода выполняется:',
      [
        'сбор семантики и ключевых запросов',
        'оптимизация структуры страниц',
        'написание SEO текстов',
        'настройка мета-тегов (title, description)',
        'работа с внутренней оптимизацией',
        'подключение аналитики (Яндекс Метрика, Google Analytics)',
      ],
      'Также можно подключить:',
      ['контекстную рекламу (Яндекс Директ)', 'ретаргетинг', 'медийную рекламу'],
      'В итоге сайт становится не просто страницей в интернете, а полноценным инструментом продаж.',
    ],
  },
  {
    question: 'Подходит ли сайт под ключ для бизнеса?',
    blocks: [
      'Сайт под ключ подходит практически для любого бизнеса.',
      'Он особенно эффективен для:',
      ['услуг (строительство, ремонт, медицина, образование)', 'интернет магазинов', 'B2B компаний', 'стартапов и новых проектов', 'локального бизнеса и офлайн компаний'],
      'Почему это работает:',
      ['сайт создается под конкретные задачи бизнеса', 'учитывается поведение целевой аудитории', 'формируется продающая структура', 'подключаются инструменты маркетинга'],
      'Сайт под ключ помогает:',
      ['привлекать клиентов из поиска', 'увеличивать продажи', 'автоматизировать обработку заявок', 'усиливать бренд компании'],
    ],
  },
];

function BulletList({ items }) {
  return (
    <ul className="source-list">
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
}

function TextBlocks({ blocks }) {
  return (
    <>
      {blocks.map((block, index) =>
        Array.isArray(block) ? <BulletList items={block} key={`list-${index}`} /> : <p key={block}>{block}</p>
      )}
    </>
  );
}

function Paragraphs({ paragraphs }) {
  return paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>);
}

function SectionHeader({ eyebrow, title, description, dark = false }) {
  return (
    <div className={`sec-head${dark ? ' ink-head' : ''}`}>
      <div>
        <div className={`eyebrow${dark ? ' cyan' : ''}`}>{eyebrow}</div>
        <h2>{title}</h2>
      </div>
      <p className="sub">{description}</p>
    </div>
  );
}

function WebsiteDevelopmentPage() {
  const [openFaq, setOpenFaq] = useState(0);

  return (
    <RedesignPage>
      <PageMeta
        title="Разработка и создание сайта под ключ - заказать изготовление сайта под ключ по выгодной цене"
        description="Закажите профессиональную разработку сайта любой сложности под ключ. Создание сайта под ключ - реализация любых запросов, качественно и в короткие сроки. Любые cms-системы, индивидуальная разработка, интеграции, продвижение. Системный подход, множество кейсов и команда профессионалов. Разработали более 150 сайтов. Рассчитайте стоимость в веб-студии fatalitystudio.ru или по телефону +7 (925) 653-04-54 !"
      />
      <RedesignHeader />

      <section className="ink service-hero">
        <div
          className="glow"
          style={{ right: '-360px', top: '-340px', width: '980px', height: '980px', opacity: 0.1 }}
        />
        <div className="container service-hero-grid">
          <div>
            <div className="eyebrow cyan">— разработка сайтов · под ключ</div>
            <h1>Разработка сайта под ключ</h1>
            <p className="hero-sub">
              Создание сайта под ключ — это комплексная разработка веб-ресурса с нуля. Проект включает дизайн,
              программирование, SEO-оптимизацию и запуск. Такой сайт сразу и в короткие сроки готов к работе,
              продвижению и привлечению клиентов из интернета.
            </p>
            <div className="hero-ctas">
              <SiteLink href="#websites-lead" className="btn btn-primary">
                Сделать сайт под ключ - в Fatality
              </SiteLink>
              <SiteLink href="/portfolio/tech-store/" className="btn btn-ghost-dark">
                примеры с результатами
              </SiteLink>
            </div>
          </div>
          <div className="service-hero-panel" aria-label="Создание сайта под ключ включает">
            {siteIncludes.map((item, index) => (
              <div className="panel-line" key={item}>
                <span>{String(index + 1).padStart(2, '0')}</span>
                <b>{item}</b>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader
            eyebrow="— бизнес"
            title="Разработка сайта под ключ для бизнеса"
            description="Разработка сайта под ключ решает задачи бизнеса. Компания получает готовый инструмент продаж. Сайт работает в интернете 24/7 и привлекает клиентов."
          />
          <div className="split-proof">
            <div>
              <p>Создание сайта под ключ включает:</p>
              <BulletList items={siteIncludes} />
              <p>
                Такой подход позволяет сразу запустить сайт, который приносит трафик и заявки.
              </p>
            </div>
            <div>
              <h2 className="standalone-h2">Какие задачи решает сайт под ключ</h2>
              <p>Сайт под ключ помогает бизнесу расти. Он закрывает задачи маркетинга и продаж.</p>
              <p>Основные задачи:</p>
              <BulletList items={businessTasks} />
              <p>Сайт становится полноценным инструментом развития бизнеса.</p>
              <SiteLink href="#websites-lead" className="btn btn-primary section-action">
                Сделать сайт под ключ - в Fatality
              </SiteLink>
            </div>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader
            eyebrow="— виды сайтов"
            title="Какие сайты мы создаем под ключ"
            description="Мы разрабатываем сайты под ключ для разных задач и ниш."
          />
          <div className="svc-grid website-type-grid">
            {siteTypes.map((item, index) => {
              const content = <>
                <div className="svc-top">
                  <div className="svc-num">{String(index + 1).padStart(2, '0')} / сайт</div>
                  <div className="svc-arrow">↗</div>
                </div>
                <h3>{item.title}</h3>
                <Paragraphs paragraphs={item.paragraphs} />
                <span className="link-flat">Узнать стоимость</span>
                <div className="svc-meta">{item.meta}</div>
              </>;

              return item.href ? (
                <SiteLink href={item.href} className="svc" key={item.title}>{content}</SiteLink>
              ) : (
                <div className="svc" key={item.title}>{content}</div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader
            eyebrow="— состав работ"
            title="Что входит в разработку сайта под ключ"
            description="Создание сайта под ключ включает полный цикл работ."
          />
          <div className="process-rail process-rail-five">
            {includedSteps.map((item, index) => (
              <div className="process-step" key={item.title}>
                <div className="process-num">{String(index + 1).padStart(2, '0')}</div>
                <h3>{item.title}</h3>
                <Paragraphs paragraphs={item.paragraphs} />
              </div>
            ))}
          </div>
          <SiteLink href="#websites-lead" className="btn btn-primary section-action">
            Начать проект
          </SiteLink>
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container">
          <SectionHeader
            eyebrow="— технологии"
            title="Технологии разработки сайтов под ключ"
            description="Используем современные технологии разработки."
            dark
          />
          <div className="tech-tiles">
            {technologies.map((item, index) => (
              <div className="tech-tile" key={item.title}>
                <div className="why-n">{String(index + 1).padStart(2, '0')}</div>
                <h3>{item.title}</h3>
                <Paragraphs paragraphs={item.paragraphs} />
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader
            eyebrow="— процесс"
            title="Как проходит создание сайта под ключ"
            description="Процесс разработки разбит на этапы."
          />
          <div className="process-rail process-rail-five">
            {creationSteps.map((item, index) => (
              <div className="process-step" key={item.title}>
                <div className="process-num">{String(index + 1).padStart(2, '0')}</div>
                <h3>{item.title}</h3>
                <Paragraphs paragraphs={item.paragraphs} />
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader
            eyebrow="— подход"
            title="Подход к разработке сайтов под ключ"
            description="Мы используем системный подход."
          />
          <div className="compact-card-grid">
            {approachItems.map((item, index) => (
              <div className="compact-card" key={item.title}>
                <div className="compact-num">{String(index + 1).padStart(2, '0')}</div>
                <h3>{item.title}</h3>
                <Paragraphs paragraphs={item.paragraphs} />
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container">
          <SectionHeader eyebrow="— форматы" title="Форматы сотрудничества" description="Разработка под задачу и формат бизнеса." dark />
          <div className="compact-card-grid">
            {collaborationFormats.map((item, index) => (
              <div className="compact-card interactive-card" key={item.title}>
                <div className="compact-num">{String(index + 1).padStart(2, '0')}</div>
                <h3>{item.title}</h3>
                <Paragraphs paragraphs={item.paragraphs} />
                <SiteLink href="#websites-lead" className="link-flat">
                  Выбрать этот формат
                </SiteLink>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader eyebrow="— итог" title="Что вы получаете в итоге" description="Готовый сайт под ключ с SEO-структурой и возможностью развития." />
          <div className="compact-card-grid">
            {deliverables.map((item, index) => (
              <div className="compact-card" key={item.title}>
                <div className="compact-num">{String(index + 1).padStart(2, '0')}</div>
                <h3>{item.title}</h3>
                <Paragraphs paragraphs={item.paragraphs} />
              </div>
            ))}
          </div>
          <SiteLink href="#websites-lead" className="btn btn-primary section-action">
            Заказать разработку сайта под ключ
          </SiteLink>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader
            eyebrow="— поддержка"
            title="Поддержка и развитие сайта"
            description="Техническая поддержка, SLA и гарантии, доработки и ведение сайта под ключ."
          />
          <div className="compact-card-grid">
            {supportItems.map((item, index) => (
              <div className="compact-card" key={item.title}>
                <div className="compact-num">{String(index + 1).padStart(2, '0')}</div>
                <h3>{item.title}</h3>
                <Paragraphs paragraphs={item.paragraphs} />
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader
            eyebrow="— стоимость"
            title="Стоимость разработки сайта под ключ"
            description="Цена зависит от сложности проекта."
          />
          <div className="pricing-layout">
            <div className="price-list">
              <h3 className="pricing-subhead">От чего зависит цена сайта под ключ</h3>
              <BulletList items={priceFactors} />
              <h3 className="pricing-subhead">Примерные цены на сайты под ключ</h3>
              <div className="price-row price-row-three price-row-head">
                <span>Тип сайта под ключ</span>
                <small>Срок</small>
                <b>Стоимость</b>
              </div>
              {prices.map(([type, time, price]) => (
                <div className="price-row price-row-three" key={type}>
                  <span>{type}</span>
                  <small>{time}</small>
                  <b>{price}</b>
                </div>
              ))}
            </div>
            <div className="price-note">
                <h3>Разработка сайта под ключ в Москве</h3>
              <p>В Москве стоимость выше из-за конкуренции.</p>
              <p>Но и требования к качеству выше.</p>
              <h3>Как рассчитывается стоимость сайта под ключ</h3>
              <p>Проводится анализ проекта.</p>
              <p>Оценивается объем работ.</p>
              <p>Формируется коммерческое предложение.</p>
              <h3>Получить расчет стоимости</h3>
              <p>Есть идея или проект? Оставьте заявку — рассчитаем стоимость и предложим решение.</p>
              <SiteLink href="#websites-lead" className="btn btn-primary">
                Получить расчёт бесплатно
              </SiteLink>
            </div>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader
            eyebrow="— рядом"
            title="Похожие услуги"
            description="Разработка корпоративных сайтов, создание лендингов, разработка интернет-магазинов, разработка сайта-услуг, SEO под ключ, продвижение в Яндекс.Картах."
          />
          <div className="related-grid">
            {relatedServices.map((item) => (
              <SiteLink href={item.href} className="related-card" key={item.title}>
                <h3>{item.title}</h3>
                <span>{item.meta}</span>
              </SiteLink>
            ))}
          </div>
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container">
          <SectionHeader
            eyebrow="— кейсы"
            title="Кейсы разработки сайтов под ключ"
            description="Примеры с результатами"
            dark
          />
          <h3 className="pricing-subhead">Примеры с результатами</h3>
          <SiteLink href="/portfolio/tech-store/" className="case-teaser case-teaser-telstore">
            <TelStoreCover preview wide alt="" />
            <div className="case-teaser-body">
              <div className="eyebrow cyan">— пример с результатом</div>
              <h3>Создание интернет-магазина техники в Москве</h3>
              <p>Примеры с результатами</p>
              <span className="link-flat">открыть кейс</span>
            </div>
          </SiteLink>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader
            eyebrow="— отзывы"
            title="Отзывы клиентов: от идеи — к готовому сайту и заявкам"
            description="Отзывы показывают реальный результат разработки сайта под ключ."
          />
          <ReviewsCarousel className="reviews-grid reviews-grid-three">
            {reviews.map((review) => (
              <figure className="review-card" aria-label={review.full} key={review.name}>
                <blockquote>{review.text}</blockquote>
                <figcaption>
                  <b>{review.name}</b>
                  <span>{review.role}</span>
                </figcaption>
              </figure>
            ))}
          </ReviewsCarousel>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <div className="faq-grid">
            <div>
              <div className="eyebrow">— faq</div>
              <h2 className="standalone-h2">Ответы на частые вопросы</h2>
            </div>
            <div className="faq-list">
              {faqItems.map((item, index) => {
                const isOpen = openFaq === index;
                return (
                  <div className={`faq-item${isOpen ? ' open' : ''}`} key={item.question}>
                    <button className="faq-q" type="button" onClick={() => setOpenFaq(isOpen ? -1 : index)}>
                      <h3 className="faq-question-heading">{item.question}</h3>
                      <span className="faq-toggle">+</span>
                    </button>
                    <div className="faq-a">
                      <div className="faq-a-inner">
                        <TextBlocks blocks={item.blocks} />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <section className="ink lead" id="websites-lead">
        <div
          className="glow"
          style={{ left: '-300px', top: '-200px', width: '700px', height: '700px', opacity: 0.1 }}
        />
        <div className="container" style={{ position: 'relative' }}>
          <div className="lead-grid">
            <div className="lead-side">
              <div className="eyebrow cyan">— заявка</div>
              <h2 className="lead-heading">Заказать разработку сайта под ключ</h2>
              <p className="lead-text">Напишите нам!</p>
              <p className="lead-text">
                P.S. Мы сами не любим холодные продажи и “впаривание услуг”, поэтому напишите в кратком описании, как Вам
                удобнее обсудить проект. 😀
              </p>
              <p className="lead-text">
                Специалисты свяжутся в удобном для Вас формате и предложат лучшее для Вас решение по цене, срокам и
                функционалу.
              </p>
              <p className="lead-text">
                Разработка сайта под ключ — это инвестиция в рост бизнеса, трафика и продаж.
              </p>
            </div>
            <div className="lead-form-stack">
              <LeadForm
                formId="websites-lead-form"
                idPrefix="websites"
                contactLabel="Телефон или E-mail"
                contactType="text"
                contactPlaceholder="+7 или почта"
                showTelegram={false}
                showCompany={false}
                typeLabel="Тип сайта"
                typeOptions={[
                  'Лендинг сайт под ключ',
                  'Сайт визитка под ключ',
                  'Корпоративный сайт под ключ',
                  'Интернет магазин под ключ',
                  'Сайт с интеграциями',
                ]}
                submitLabel="Получить расчёт бесплатно"
                taskPlaceholder="Комментарий"
              />
              <div className="manager-note lead-manager-note">
                {/* TODO(brand-redesign): add the manager photo and name from the source brief. */}
                <span aria-hidden="true" />
                <p>Отвечу в течение 1 часа</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <RedesignFooter />
    </RedesignPage>
  );
}

export default WebsiteDevelopmentPage;
